// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__b3319b117a1f04802b9a","cls2":"SimplePaperPodcast-cls2___60a4d21c5643ec4bcf5 SimplePaperPodcast-cls1__b3319b117a1f04802b9a"};